import {
  ChangeDetectionStrategy,
  Component,
  input,
  InputSignal,
  output,
  OutputEmitterRef,
} from '@angular/core';
import { ButtonComponent } from '@libs/common/components';

@Component({
  selector: 'ui-shopping-list-actions',
  imports: [ButtonComponent],
  templateUrl: './shopping-list-actions.component.html',
  styleUrl: './shopping-list-actions.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ShoppingListActionsComponent {
  public selectedLength: InputSignal<number> = input.required();
  public isMobile: InputSignal<boolean> = input.required();
  public addToCart: OutputEmitterRef<void> = output();
  public removeItems: OutputEmitterRef<void> = output();
}
